import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from 'react-i18next';
import {Button, CardActions} from '@material-ui/core';
import ReactsCard from "../components/ui/ReactsCard";
import GuestList from "../components/pro-guest/provier-guests/GuestList";
import {useNavigate} from "react-router-dom";
import {WithOrganization} from "../components/organizations/organization-context";
import {CsvExport} from "../components/_shared/CSVExport";
import {getAllMyGuests, getGuestStatus} from "../api/pro-guest-functions";
import {useNotification} from "../components/ui/notification/NotificationProvider";
import {useAuthentication} from "../auth/AuthProvider";


const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 250,
        margin: theme.spacing(4)
    },
    action: {
        justifyContent: 'flex-end'
    }
}));


const MyGuests: React.FC<WithOrganization> = ({currentOrganization}) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {getUser} = useAuthentication();
    const {pushError} = useNotification();

    const addGuest = () => {
        navigate("/my-guests/add")
    };

    const guestsCsvFilenameBuilder = async () => {
        const user = await getUser();
        return `${t(`MyGuests.ExportFilename`, {firstName: user?.FirstName, lastName: user?.LastName})}.csv`
    }

    const guestsCsvContentBuilder = async () => {
        const guests = await getAllMyGuests(currentOrganization?.id);

        const data = guests.map((g: any) => [
            g.firstName,
            g.lastName,
            g.email,
            t(`ProGuest.Guests.Table.Status.${getGuestStatus(g)}`)
        ]);

        const headers = [
            t(`_Common.Labels.FirstName`),
            t(`_Common.Labels.LastName`),
            t(`_Common.Labels.Email`),
            t('ProGuest.Guests.Table.Headers.Status')
        ]
        return {data, headers};
    }

    return (
        <ReactsCard title={t('MyGuests.Title')} className={classes.root}>
            <CardActions className={classes.action}>
                <CsvExport
                    contentBuilder={guestsCsvContentBuilder}
                    filenameBuilder={guestsCsvFilenameBuilder}
                    onError={(message: any) => pushError({message})}
                >
                    {t('_Shared.CSV.Export')}
                </CsvExport>
                <Button variant="contained" color="primary" size="medium"
                        onClick={addGuest}>
                    {t('MyGuests.AddGuest')}
                </Button>
            </CardActions>
            <GuestList organizationId={currentOrganization.id}/>
        </ReactsCard>
    );
};

export default MyGuests;
